/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { Column } from "../partials/containerTable";

export const getLotColumns = (t: any): Column[] => [
  {
    header: t('containerInventory.containerBatchDetails.LotIdentifier'),
    key: "lot_code",
    render: (row) => (
      <td className="px-10 py-3">
        <span className="text-[12px] font-black text-[#FF7043] uppercase tracking-wide bg-orange-50 px-2 py-0.5 rounded border border-orange-100">
          {row.lot_code}
        </span>
      </td>
    ),
  },
  {
    header: t('containerInventory.containerBatchDetails.LotName'),
    key: "lot_serial",
    render: (row) => (
      <td className="px-10 py-3">
        <span className="text-sm font-bold text-slate-600 uppercase">
          {row.lot_serial}
        </span>
      </td>
    ),
  },
  {
    header: t('containerInventory.containerBatchDetails.Quantity'),
    key: "lot_size",
    render: (row) => (
      <td className="px-10 py-3">
        <span className="text-sm font-bold text-slate-600 uppercase">
          {row.lot_size} Units
        </span>
      </td>
    ),
  },
];